var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecipeCardNUmberBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 208,
    viewBox: "0 0 246 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M245.244 171.598L211.766 207.377L178.293 171.598H245.244Z",
    fill: "url(#paint0_linear_8549_4780)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177.993 0H0V171.152L33.4729 206.932H211.472L177.993 171.152V0Z",
    fill: "url(#paint1_linear_8549_4780)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M178.293 171.598H0.299805L33.7727 207.377H211.772L178.293 171.598Z",
    fill: "url(#paint2_linear_8549_4780)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8549_4780",
    x1: 194.906,
    y1: 173.745,
    x2: 206.406,
    y2: 211.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8549_4780",
    x1: 52.4731,
    y1: 12.4199,
    x2: 153.58,
    y2: 191.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8549_4780",
    x1: 52.7729,
    y1: 173.745,
    x2: 56.7226,
    y2: 214.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipeCardNUmberBg);
export default __webpack_public_path__ + "static/media/recipeCardNUmberBg.083a40a5c7e341a31e768af70901d95b.svg";
export { ForwardRef as ReactComponent };